<template>
    <v-container fluid>
        <mail-form :model="model" v-if="model" @saved="saved" />
        <v-row v-else>
            <v-col class="text-center">
                <v-progress-circular
                    :size="50"
                    color="primary"
                    indeterminate
                ></v-progress-circular>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import MailForm from './Form'
import Mail from '@/models/settings/Mail'

export default {
    components: {
        MailForm,
    },

    props: {
        id: {
            required: true,
        },
    },

    data() {
        return {
            model: null,
        }
    },

    methods: {
        async findModel() {
            let model = await new Mail().find(this.id)
            this.model = model
        },

        saved() {
            this.$router.push({
                name: this.$t('routes.mail.index'),
            })
        },
    },

    created() {
        this.findModel()
    },
}
</script>

<style></style>
